import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Pagination,
  Modal,
  Form,
  Tab,
  Tabs,
} from 'react-bootstrap';
import Service from '../assets/icon/management.png';
import Footer from '../../Components/Footer';

import { useHistory } from 'react-router-dom';
import TabsIcon from '../Components/layout/TabsIcon';
import GroupButtonStock from '../Components/layout/GroupButtonStock';
import { DatePicker, Space } from 'antd';
import Calendar from '../assets/icon/calendar-bg.png';
import NotificationImage from 'assets/icon/notification.png'

import Back from '../assets/icon/back.png';

import All from '../Components/Notification/AllLists';
import OrderRequest from '../Components/Notification/OrderRequest';
import AlmostOutStock from '../Components/Notification/AlmostOutStock';
import OutStock from '../Components/Notification/OutStock';

export default function Index() {
  const history = useHistory();
  const [key, setKey] = useState('all');

  function close() {
    history.push(`/`);
  }

  return (
    <>
      
      <Container fluid className="package-container Service Stock Job bg-mrk">
        <div className="package">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  <img className="logo pr-2" src={NotificationImage} />
                  Notification
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={close}
                >
                  <span aria-hidden="true">X</span>
                </button>
              </div>
              <div className="modal-header-mobile">
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={close}
                >
                  <img src={Back} />
                </button>
                <h5 className="modal-title" id="exampleModalLabel">
                  <img className="logo pr-2" src={NotificationImage} />
                  Notification
                </h5>
              </div>
              <div className="modal-body">
                <Row className="g-0 tabsicon justify-content-center ">
                  <TabsIcon />
                </Row>
                <Row className="g-0 justify-content-center ">
                  <Col>
                    <Tabs
                      id="controlled-tab-example"
                      activeKey={key}
                      onSelect={(k) => setKey(k)}
                      className="mb-3"
                    >
                      <Tab eventKey="all" title="ทั้งหมด">
                        <All />
                      </Tab>
                      <Tab eventKey="รับสินค้า" title="รับสินค้า">
                        <OrderRequest />
                      </Tab>
                      <Tab eventKey="อนุมัติเบิก" title="อนุมัติเบิก">
                        <AlmostOutStock />
                      </Tab>
                      <Tab eventKey="ยกเลิกเบิก" title="ยกเลิกเบิก">
                        <OutStock />
                      </Tab>
                    </Tabs>
                  </Col>
                </Row>
                <Row className="g-0 justify-content-center mt-3"></Row>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
}
